import { render, staticRenderFns } from "./Col6.vue?vue&type=template&id=411beba1&scoped=true"
import script from "./Col6.vue?vue&type=script&lang=js"
export * from "./Col6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411beba1",
  null
  
)

export default component.exports